const router = [
  {
    path: '/project-publicity-list',
    name: 'ProjectPublicityList',
    component: () => import('../views/ProjectPublicity/ProjectPublicityList.vue')
  },
  {
    path: '/project-publicity-info',
    name: 'ProjectPublicityInfo',
    component: () => import('../views/ProjectPublicity/ProjectPublicityInfo.vue')
  },
  {
    path: '/project-publicity-step',
    name: 'ProjectPublicityStep',
    component: () => import('../views/ProjectPublicity/ProjectPublicityStep.vue')
  },
]

export default router
